import { defineMessages } from 'react-intl';

type MessageKeys = 'maximizeChatButtonLabel' | 'minimizeChatButtonLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		maximizeChatButtonLabel: {
			id: 'ai-mate.main-chat.maximize-chat-button-label',
			defaultMessage: 'Full screen',
			description: 'Label for the maximize chat button',
		},
		minimizeChatButtonLabel: {
			id: 'ai-mate.main-chat.minimize-chat-button-label',
			defaultMessage: 'Restore view',
			description: 'Label for the minimize chat button',
		},
	});

export default message;
